import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import styled from 'styled-components';
import { BlankIcon } from 'foundations-assets/icons/components/BlankIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IconShrinker = styled.div.withConfig({
  displayName: "ACStep__IconShrinker"
})(["font-size:10px;z-index:2;margin-top:-2px;position:relative;"]);
const getIconStyles = (active, completed) => {
  let state;
  if (active && completed) {
    state = 'activeCompleted';
  } else if (!active && completed) {
    state = 'completed';
  } else if (active && !completed) {
    state = 'active';
  } else {
    state = 'default';
  }
  const styleMap = {
    activeCompleted: {
      backgroundColor: 'fill-field-default-alt',
      borderColor: 'border-brand-default',
      color: 'icon-secondary-default'
    },
    completed: {
      backgroundColor: 'fill-brand-default',
      borderColor: 'border-brand-default',
      color: 'icon-core-on-fill-default'
    },
    active: {
      backgroundColor: 'fill-field-default-alt',
      borderColor: 'border-brand-default',
      color: 'icon-secondary-default'
    },
    default: {
      backgroundColor: 'fill-field-default-alt',
      borderColor: 'border-core-default',
      color: 'icon-secondary-default'
    }
  };
  return styleMap[state];
};
export const StepConnector = styled.div.withConfig({
  displayName: "ACStep__StepConnector"
})(["position:absolute;width:2px;z-index:2;left:50%;transform:translateX(-50%);top:", ";height:100%;background-color:", ";"], ({
  topOffset,
  theme
}) => topOffset ? theme.space[topOffset] : '0', ({
  theme,
  active
}) => active ? theme.color['border-brand-default'] : theme.color['border-core-default']);
export const StepIcon = ({
  active,
  completed
}) => {
  const {
    backgroundColor,
    borderColor,
    color
  } = getIconStyles(active, completed);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(IconShrinker, {
      children: /*#__PURE__*/_jsx(IconCircle, {
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderStyle: "solid",
        borderWidth: "200",
        color: color,
        "data-is-active": active,
        "data-is-completed": completed,
        "data-test-id": "step-icon",
        icon: completed ? SuccessIcon : BlankIcon,
        padding: "50",
        size: "inherit"
      })
    })
  );
};
export const ACStep = ({
  showConnector,
  iconActive,
  connectorActive,
  iconOffset,
  completed
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    position: "relative",
    children: [showConnector &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StepConnector, {
      active: connectorActive,
      topOffset: iconOffset
    }), /*#__PURE__*/_jsx(Box, {
      paddingBlockStart: iconOffset,
      children: /*#__PURE__*/_jsx(StepIcon, {
        active: iconActive,
        completed: completed
      })
    })]
  });
};